module.exports = __webpack_public_path__ + "static/hs-020203d31770e1dd1e606a0a3cf29c12.png";